/**
 * Check if the given value is falsy
 * @param {*} value Value to check
 * @param value
 * @returns {boolean}
 */
export default function isFalsy(value) {
    return value === null
        || value === undefined
        || value === ''
        || value === false
        || value === 0;
}